import axios from 'axios';
import { API_DOMAIN } from '../../../components/constants';
import { apiGet, authHeaders } from '../../../components/qv4/models/shared/apiClient';

// Every Google call except drawing the interactive map goes through our
// server (API_REFERENCE "Maps proxy"); the server key never reaches the web.
const query = params => new URLSearchParams(params).toString();

export function mapsConfig() {
  return apiGet('/maps/config').then(res => res.data?.data || null);
}

export function autocomplete(input, sessionToken) {
  return apiGet(`/maps/autocomplete?${query({ input, session_token: sessionToken })}`).then(res => res.data?.data || []);
}

export function placeDetails(placeId, sessionToken) {
  return apiGet(`/maps/places/${encodeURIComponent(placeId)}?${query({ session_token: sessionToken })}`).then(res => res.data?.data || null);
}

export function reverseGeocode(latitude, longitude) {
  return apiGet(`/maps/reverse-geocode?${query({ lat: String(latitude), lng: String(longitude) })}`).then(res => res.data?.data ?? null);
}

// An <img> can't send the accessToken header, so previews are fetched as blobs.
export function staticImage({ latitude, longitude, zoom = 15, width = 330, height = 180 }) {
  const params = query({ lat: String(latitude), lng: String(longitude), zoom: String(zoom), width: String(width), height: String(height) });
  return axios.get(`${API_DOMAIN}/maps/static?${params}`, { ...authHeaders(), responseType: 'blob' }).then(res => res.data);
}

export function newSessionToken() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(bytes);
  else for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40; bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function mapsErrorCopy(error) {
  const status = error?.response?.status, code = error?.response?.data?.code;
  if (status === 429 || code === 'RATE_LIMITED') return 'Too many map lookups. Wait a minute and try again.';
  if (code === 'MAPS_NOT_CONFIGURED') return 'Maps are not set up on the server yet.';
  if (code === 'MAPS_INPUT_INVALID') return 'That search could not be used. Try different words.';
  return 'Maps could not answer right now. Try again, or paste coordinates.';
}
